module.exports = __webpack_public_path__ + "img/4.4eee0411.png";